var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaystackActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#fafcf8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.4798V17.5198C16.5 17.1222 16.8224 16.7998 17.22 16.7998H27.18C27.5776 16.7998 27.9 17.1222 27.9 17.5198V18.4798C27.9 18.8774 27.5776 19.1998 27.18 19.1998H17.22C16.8224 19.1998 16.5 18.8774 16.5 18.4798Z",
    fill: "#89B369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.4798V20.5198C16.5 20.1222 16.8224 19.7998 17.22 19.7998H27.78C28.1776 19.7998 28.5 20.1222 28.5 20.5198V21.4798C28.5 21.8774 28.1776 22.1998 27.78 22.1998H17.22C16.8224 22.1998 16.5 21.8774 16.5 21.4798Z",
    fill: "#89B369"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24.4798V23.5198C16.5 23.1222 16.8224 22.7998 17.22 22.7998H27.18C27.5776 22.7998 27.9 23.1222 27.9 23.5198V24.4798C27.9 24.8774 27.5776 25.1998 27.18 25.1998H17.22C16.8224 25.1998 16.5 24.8774 16.5 24.4798Z",
    fill: "#89B369"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 27.4798V26.5198C16.5 26.1222 16.8224 25.7998 17.22 25.7998H22.98C23.3776 25.7998 23.7 26.1222 23.7 26.5198V27.4798C23.7 27.8774 23.3776 28.1998 22.98 28.1998H17.22C16.8224 28.1998 16.5 27.8774 16.5 27.4798Z",
    fill: "#89B369"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystackActive);
export default __webpack_public_path__ + "static/media/paystack-active.f5614e93b2d5909f360183039f2b0fb4.svg";
export { ForwardRef as ReactComponent };